import JwtService from '@/common/jwt.service'

export default {
  data () {
    return {
      cbSaveLoginId: false
    }
  },
  methods: {
    doSaveLoginId (loginId) {
      JwtService.saveCookie('savedLoginId', {
        loginId: this.cbSaveLoginId ? loginId : null,
        cbSaveLoginId: this.cbSaveLoginId
      })
    }
  }
}
